export const REGIONS = ['Northeast', 'Midwest', 'Southeast', 'Texas', 'West'] as const;

export const DEFAULT_COUNTRY_ISO2 = 'US';
export const DEFAULT_COUNTRY_ISO3 = 'USA';
